module.exports = __webpack_public_path__ + "media/customizations/spanishpeaks/logo-d609a64dfb876b4ec5b01e7fac543ce7.png";